<template>
  <div>
    <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;">
      <v-flex sm3 md4 lg2>
        <v-checkbox
            label="Pending"
            :value="filters.Pending"
            row
            v-model="filters.Pending"
            @change="filterPending($event)"
            class="request_checkbox"
            :color="'black'"
        ></v-checkbox>
      </v-flex>
      <v-flex sm3 md4 lg2 style="margin-right: 30px;">
        <v-checkbox
            label="Published"
            :value="filters.Published"
            v-model="filters.Published"
            @change="filterPublished($event)"
            class="request_checkbox"
            :color="'black'"
        ></v-checkbox>
      </v-flex>

      <v-flex sm3 md4 lg2 style="margin-right: 20px;">
        <v-checkbox
            label="Rejected"
            :value="filters.Rejected"
            v-model="filters.Rejected"
            @change="filterRejected($event)"
            class="request_checkbox"
            :color="'black'"
        ></v-checkbox>
      </v-flex>

      <v-flex sm3 md4 lg2 style="margin-right: 30px;">
        <v-checkbox
            label="Archived"
            :value="filters.Archived"
            v-model="filters.Archived"
            @change="filterArchived($event)"
            class="request_checkbox"
            :color="'black'"
        ></v-checkbox>
      </v-flex>
    </v-layout>

    <v-data-table
        :headers="headers"
        :items="hacksList"
        class="elevation-1"
        v-model="hacks"
        item-key="id"
        :loading="loaders.hack_list_loader"
        :total-items="total_items"
        :pagination.sync="pagination"
        :rows-per-page-items="[10, 20, 50, 100]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left" v-if="props.item.description">{{ props.item.description }}</td>
        <td v-else> {{ " - " }}</td>

        <td class="text-xs-left" v-if="props.item.hack_related_to">{{ props.item.hack_related_to }}</td>
        <td v-else> {{ " - " }}</td>

        <td class="text-xs-left" v-if="props.item.created_by_user != null">
          {{ props.item.created_by_user.first_name + " " + props.item.created_by_user.last_name }}
        </td>
        <td v-else>{{ " - " }}</td>

        <td class="text-xs-left">
        <span>
          <v-menu
              transition="slide-y-transition"
              bottom>
<!--            :disabled="props.item.status == 'Rejected' || props.item.status == 'Archived'"-->
            <template v-slot:activator="{ on }">
              <div v-on="on" style="cursor: pointer;">
              <v-chip color="#C8E6C9" text-color="#1B5E20"
                      v-if="props.item.status == 'Published'"><span style="cursor: pointer;">{{ props.item.status }}</span></v-chip>

              <v-chip color="#F7F7B5" text-color="#E0AC49"
                      v-else-if="props.item.status == 'Pending'" class="v-chip--active"><span style="cursor: pointer;">{{ props.item.status
                }}</span></v-chip>

                  <v-chip color="#FCCECB" text-color="#F44336" :class="{'disabled' : isChipDisabled }"
                          v-else-if="props.item.status == 'Rejected'" :disabled="props.item.status == 'Rejected'">
                    <span style="cursor: pointer;">{{ props.item.status }}</span></v-chip>

                  <v-chip color="#d2b5a1" text-color="#794936"
                          v-else-if="props.item.status == 'Archived'"><span style="cursor: pointer;">{{
                      props.item.status }}</span></v-chip>
            </div>
            </template>
                <v-list>
                  <v-list-tile
                      v-for="(item, i) in status"
                      :key="i">
                <v-list-tile-title @click="hackStatus(item.value, props.item.id)" style="cursor: pointer;">
                  {{ item.value }}</v-list-tile-title>
              </v-list-tile>
<!--                  <v-list-tile><v-list-tile-title @click="hackStatus('Pending', props.item.id)"-->
<!--                                                  style="cursor: pointer;">-->
<!--                    {{ 'Pending' }}</v-list-tile-title>-->
<!--                  </v-list-tile>-->

<!--                  <v-list-tile v-if="props.item.status == 'Pending'"><v-list-tile-title @click="hackStatus('Published',-->
<!--                  props.item.id)" style="cursor: pointer;">-->
<!--                    {{ 'Published' }}</v-list-tile-title>-->
<!--                  </v-list-tile>-->
<!--                  <v-divider></v-divider>-->

<!--                  <v-list-tile v-if="props.item.status == 'Pending'"><v-list-tile-title @click="hackStatus('Rejected', props.item.id)"-->
<!--                                                  style="cursor: pointer;">-->
<!--                    {{ 'Rejected' }}</v-list-tile-title>-->
<!--                  </v-list-tile>-->
<!--                  <v-divider></v-divider>-->

<!--                  <v-list-tile v-if="props.item.status == 'Published'"><v-list-tile-title @click="hackStatus('Archived', props.item.id)"-->
<!--                                                  style="cursor: pointer;">-->
<!--                    {{ 'Archived' }}</v-list-tile-title>-->
<!--                  </v-list-tile>-->
<!--                  <v-divider></v-divider>-->


            </v-list>
              </v-menu>
        </span>
        </td>

        <td class="text-xs-left">{{ moment(props.item.created_at).format("Do MMM YYYY hh:mm a") }}</td>
        <td>
          <v-flex style="display: flex;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on , attrs}">
                <v-btn text icon :disabled="!checkPermission('update-travel-hack') || props.item.status == 'Rejected'" v-on="on"
                       v-bind="attrs" small
                       @click="showHack(props.item.id)">
                  <v-icon class="material-icons" color="blue">edit</v-icon>
                </v-btn>
              </template>
              <span>Edit Hack</span>
            </v-tooltip>


<!--            <v-tooltip bottom>-->
<!--              <template v-slot:activator="{ on }">-->
<!--                <v-btn text icon :disabled="!checkPermission('update-travel-hack') || (props.item.status == 'Rejected' ||-->
<!--                props.item.status == 'Published')" v-on="on" small-->
<!--                       @click="hackStatus('Published',props.item.id)">-->
<!--                  <v-icon class="material-icons" color="green">check</v-icon>-->
<!--                </v-btn>-->
<!--              </template>-->
<!--              <span>Approve Hack</span>-->
<!--            </v-tooltip>-->

<!--            <v-tooltip bottom>-->
<!--              <template v-slot:activator="{ on }">-->
<!--                <v-btn text icon small :disabled="!checkPermission('update-travel-hack') || (props.item.status ==-->
<!--                'Rejected' ||-->
<!--                props.item.status == 'Published')" v-on="on" @click="hackStatus('Rejected',props.item.id)">-->
<!--                  <v-icon class="material-icons" color="red">clear</v-icon>-->
<!--                </v-btn>-->
<!--              </template>-->
<!--              <span>Reject Hack</span>-->
<!--            </v-tooltip>-->
          </v-flex>
        </td>
      </template>
    </v-data-table>

    <!--    Dialog to approve hack-->
    <v-dialog v-model="status_approval_dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-card-title primary-title v-if="hack_status == 'Published'">
              <h2>Are you sure you wish to Publish this Hack ? </h2>
            </v-card-title>

            <v-card-title primary-title v-else-if="hack_status == 'Rejected'">
              <h2>Are you sure you wish to Reject this Hack ? </h2>
            </v-card-title>

            <v-card-title primary-title v-else-if="hack_status == 'Archived'">
              <h2>Are you sure you wish to Archive this Hack ? </h2>
            </v-card-title>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat type="reset" small @click="status_approval_dialog = false; approvalLoader = false">Cancel</v-btn>
          <v-btn :loading="approvalLoader" :disabled="approvalLoader" color="primary" small
                 @click="updateStatus">Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!--    dialog to edit hack-->
    <v-dialog v-model="update_hack_dialog" max-width="600px">
      <v-card>
        <v-form id="update_travel_hack"
                @submit.prevent="validateBeforeSubmit('editHack')"
                data-vv-scope="editHack"
                ref="update_hack_form"
                v-model="valid">

          <v-card-title style="padding-bottom: 0px;">
            <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
              <h4 class="heading_text">Update Travel Hack</h4>
              <v-btn icon @click="update_hack_dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md12 lg12>
                <label>Description: </label>
                <v-textarea
                    name="Description"
                    v-model="update_hack_object.description"
                    rows="2"
                    label="Description"
                    v-validate="'required'"
                    solo flat
                    :error-messages="errors.collect('editHack.Description')">
                </v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6 lg8>
                <label>Hack related To: </label>
                <v-text-field
                    name="hack_related_to"
                    v-model="update_hack_object.hack_related_to"
                    label="Hack related To"
                    v-validate="'required'"
                    solo flat
                    :error-messages="errors.collect('editHack.hack_related_to')"
                ></v-text-field>
              </v-flex>
            </v-layout>

<!--            <v-flex sm12 md12 lg12 style="padding-top: 17px;">-->
<!--              <label>Status: </label>-->
<!--              <v-autocomplete-->
<!--                  :items="status"-->
<!--                  v-model="update_hack_object.status"-->
<!--                  name="Announcement Type"-->
<!--                  label="Select Train Code"-->
<!--                  return-object-->
<!--                  :item-text="getItemText"-->
<!--                  item-value="number"-->
<!--                  solo flat multiple chips deletable-chips-->
<!--              ></v-autocomplete>-->
<!--            </v-flex>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat type="reset" small @click="update_hack_dialog = false; updateLoader = false">Cancel</v-btn>
            <v-btn :loading="updateLoader" :disabled="updateLoader || (update_hack_object.hack_related_to == '' ||
            update_hack_object.description == '')"
                   color="primary" small @click="editHack">Confirm
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar
        v-model="snackbar.display"
        :color="snackbar.color"
        :top="snackbar.top"
        :bottom="snackbar.bottom"
        :left="snackbar.left"
        :right="snackbar.right"
        :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <v-btn text dark @click="snackbar.display = false">
        <v-icon right color="white"> close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Index",
  watch: {
    pagination: {
      handler() {
        this.getHackList();
      },
    },
  },
  data() {
    return {
      hacks: [],
      isChipDisabled: true,
      loaders: {
        hack_list_loader: false,
      },
      approvalLoader: false,
      status_approval_dialog: false,
      update_hack_dialog: false,
      updateLoader: false,
      hack_status: '',
      hack_id: '',
      pagination: {sortBy: "created_at", descending: false, rowsPerPage: 10},
      total_items: 0,
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
      hacksList: [],
      headers: [
        {
          text: 'Description',
          align: 'left',
          sortable: false,
          value: 'description'
        },
        {
          text: 'Related To',
          align: 'left',
          sortable: false,
          value: 'related_to'
        },
        {
          text: 'Created By',
          align: 'left',
          sortable: false,
          value: 'created by'
        },
        {
          text: 'Status',
          align: 'left',
          sortable: false,
          value: 'status'
        },
        {
          text: 'Created At',
          align: 'left',
          sortable: false,
          value: 'created_at'
        },
        {
          text: 'Action',
          align: 'left',
          value: 'action'
        }
      ],
      filters: {
        Pending: false,
        Published: false,
        Rejected: false,
        Archived: false,
      },
      update_hack_object: [],
      valid: '',
      status: [
        {
          text: 'Published',
          value: 'Published'
        },{
          text: 'Pending',
          value: 'Pending'
        },{
          text: 'Rejected',
          value: 'Rejected'
        },
        {
          text: 'Archived',
          value: 'Archived'
        }
      ]
    }
  },
  methods: {
    filterPending(value) {
      this.filters.Pending = value;
      this.filters.Rejected = false;
      this.filters.Archived = false;
      this.filters.Published = false;

      this.getHackList();
    },
    filterPublished(value) {
      this.filters.Pending = false;
      this.filters.Rejected = false;
      this.filters.Archived = false;
      this.filters.Published = value;
      this.getHackList();
    },
    filterRejected(value) {
      this.filters.Pending = false;
      this.filters.Published = false;
      this.filters.Archived = false;
      this.filters.Rejected = value;
      this.getHackList();
    },
    filterArchived(value) {
      this.filters.Pending = false;
      this.filters.Published = false;
      this.filters.Rejected = false;
      this.filters.Archived = value;
      this.getHackList();
    },
    getHackList() {
      this.loaders.hack_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-travel-hacks`, {
        params: this.pagination
      }).then((response) => {
        if (response.data.status == 1) {
          this.loaders.hack_list_loader = false;
          this.hacksList = response.data.data.data;
          this.total_items = response.data.data.total;
        } else if (response.data.status == 0) {
          this.loaders.hack_list_loader = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      }).catch((error) => {
        this.loaders.hack_list_loader = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    },
    hackStatus(status, id) {
      this.hack_status = status;
      this.hack_id = id;
      this.status_approval_dialog = true;
    },
    updateStatus() {
      this.approvalLoader = true;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-travelhack-status`, {
            id: this.hack_id, status: this.hack_status }).then((response) => {
        if (response.data.status == 1) {
          this.approvalLoader = false;
          this.status_approval_dialog = false;
          this.getHackList();
        } else if (response.data.status == 0) {
          this.approvalLoader = false;
          this.status_approval_dialog = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      }).catch((error) => {
        this.approvalLoader = false;
        this.status_approval_dialog = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    },
    showHack(id) {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/show-travel-hack/` + id).then((response) => {

        if (response.data.status == 1) {
          this.update_hack_object = response.data.data;
          this.update_hack_dialog = true;
        } else if (response.data.status == 0) {
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      });
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {

          this[scope]();
        }
      });
    },
    editHack() {
      this.updateLoader = true;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-travelhack`,
          this.update_hack_object,
          {headers: this.$headers,})
          .then((response) => {
        if (response.data.status == 1) {
          this.update_hack_dialog = false;
          this.updateLoader = false;
          this.getHackList();
        } else if (response.data.status == 0) {
          this.update_hack_dialog = false;
          this.updateLoader = false;
        }
      }).catch((error) => {
        this.updateLoader = false;
        this.update_hack_dialog = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    }
  },
  mounted() {
    this.getHackList();
  }
}
</script>

<style scoped>
.disabled {
  opacity: 0.7;
}
</style>
